import * as Sentry from '@sentry/browser'
import { ENV, CONSTANTS } from 'pobble-components/dist/setup'

const enableSentry = () => {
  Sentry.init({
    dsn: CONSTANTS.SENTRY_DSN_KEY,
    beforeSend: (event, hint) => {
      // Filter out all HTTP errors and all IE errors
      const s = hint.originalException ? hint.originalException.toString() : ''
      if (
        s.includes('Request failed with status code') ||
        s.includes(
          'Non-Error exception captured with keys: currentTarget, isTrusted, target, type'
        ) ||
        navigator.userAgent.includes('MSIE') ||
        navigator.userAgent.includes('Trident')
      ) {
        return null
      }

      return event
    }
  })
}

if (ENV === 'prod') {
  enableSentry()
}
